var html = document.documentElement;
var body = document.body;
var searchButton = document.querySelectorAll('.v-search-button');
var searchBox = document.querySelector('.v-search-box');
var searchClose = document.getElementById('searchClose');



searchButton.forEach(function(sb) {
    sb.addEventListener('click', function(e) {
        e.preventDefault();
        searchBox.classList.add('v-search-box-visible');
        body.classList.add('v-search-opened');
        searchTrigger();
    })
});
document.addEventListener('keyup', function(e) {
    if (e.keyCode == 27 && searchBox.classList.contains('v-search-box-visible') && body.classList.contains('v-search-opened')) {
        closeSearch();
    }
});
searchClose.addEventListener('keyup', function(e) {
    if (e.keyCode == 13) {
        closeSearch();
    }
});
searchClose.addEventListener('keyup', function(e) {
    if (e.keyCode == 13) {
        closeSearch();
    }
});
searchBox.onclick = closeSearch;
searchClose.onclick = closeSearch;

function closeSearch(e) {

    if (e !== undefined && e.target !== e.currentTarget) {
        return;
    }
    searchBox.classList.toggle('v-search-box-visible');
    body.classList.toggle('v-search-opened');
}
  

function searchTrigger() {

const search = instantsearch({
    indexName: 'tcl_posts',
    page: 1,
    searchClient: algoliasearch(
      'E44JSW0IXB',
      '029b8ec4a72fa3826e8cc046ae79861f'
  ),
})

    search.addWidgets([
    instantsearch.widgets.searchBox({
        container: '#searchbox',
        cssClasses: {
            form: 'v-search-form',
            input: 'it-input'
          },
        autofocus: '#searchbox input',
        placeholder: "Enter your search terms",
        showSubmit: false,
        showLoadingIndicator: false,
    }),

    instantsearch.widgets.hits({
        container: '#results',
        templates: {
          item: `
            <a class="results-item" href='{{url}}'>
                <div class="results-media">
                  <img class="lazyload" src="{{image}}">
                </div>
              <div class="result-content">
                <h6>{{#helpers.highlight}}{ "attribute": "title" }{{/helpers.highlight}}</h6>
                <p>{{#helpers.highlight}}{ "attribute": "excerpt" }{{/helpers.highlight}}</p>
              </div>
            </a>
          `,
          },
      }),
])

search.start()
setTimeout(function() {
    document.querySelector('#searchbox input').focus();
  }, 100);

}





//  // Lazy Load (New Lazyload Script)
//  function lazyLoadImages() {
//   var lazyClass = "lazyload";
//   var loadedClass = "lazyloaded";
//   var dataSrcAttribute = "data-src";
//   var dataSrcsetAttribute = "data-srcset";
//   var sourceSelector = "source";

//   var lazyImages = [].slice.call(document.querySelectorAll("." + lazyClass));

//   if ("IntersectionObserver" in window) {
//     var lazyImageObserver = new IntersectionObserver(function(entries, observer) {
//       entries.forEach(function(entry) {
//         if (entry.isIntersecting) {
//           var lazyImage = entry.target;

//           // Check if data-src attribute exists before updating attributes
//           if (lazyImage.hasAttribute(dataSrcAttribute)) {
//             lazyImage.src = lazyImage.getAttribute(dataSrcAttribute);
//             lazyImage.srcset = lazyImage.getAttribute(dataSrcsetAttribute);
            
//             // Convert sibling source elements
//             var lazySources = lazyImage.parentNode.querySelectorAll(sourceSelector);
//             lazySources.forEach(function(lazySource) {
//               lazySource.srcset = lazySource.getAttribute(dataSrcsetAttribute);
//               lazySource.removeAttribute(dataSrcsetAttribute);
//             });

//             lazyImage.removeAttribute(dataSrcAttribute);
//             lazyImage.removeAttribute(dataSrcsetAttribute);
//             lazyImage.classList.add(loadedClass);
//           }

//           lazyImageObserver.unobserve(lazyImage);
//         }
//       });
//     });

//     lazyImages.forEach(function(lazyImage) {
//       lazyImageObserver.observe(lazyImage);
//     });
//   } else {
//     // Fallback for browsers without Intersection Observer
//     lazyImages.forEach(function(lazyImage) {
//       if (lazyImage.hasAttribute(dataSrcAttribute)) {
//         lazyImage.src = lazyImage.getAttribute(dataSrcAttribute);
//         lazyImage.srcset = lazyImage.getAttribute(dataSrcsetAttribute);
        
//         // Convert sibling source elements
//         var lazySources = lazyImage.parentNode.querySelectorAll(sourceSelector);
//         lazySources.forEach(function(lazySource) {
//           lazySource.srcset = lazySource.getAttribute(dataSrcsetAttribute);
//           lazySource.removeAttribute(dataSrcsetAttribute);
//         });

//         lazyImage.classList.add(loadedClass);
//         lazyImage.removeAttribute(dataSrcAttribute);
//         lazyImage.removeAttribute(dataSrcsetAttribute);
//       }
//     });
//   }
// }


// Cards

! function() {
  const e = function(e) {
          const t = e.querySelector(".kg-audio-player-container"),
              a = e.querySelector(".kg-audio-play-icon"),
              o = e.querySelector(".kg-audio-pause-icon"),
              i = e.querySelector(".kg-audio-seek-slider"),
              d = e.querySelector(".kg-audio-playback-rate"),
              r = e.querySelector(".kg-audio-mute-icon"),
              s = e.querySelector(".kg-audio-unmute-icon"),
              l = e.querySelector(".kg-audio-volume-slider"),
              n = e.querySelector("audio"),
              c = e.querySelector(".kg-audio-duration"),
              u = e.querySelector(".kg-audio-current-time");
          let g = [{
                  rate: .75,
                  label: "0.7Ã—"
              }, {
                  rate: 1,
                  label: "1Ã—"
              }, {
                  rate: 1.25,
                  label: "1.2Ã—"
              }, {
                  rate: 1.75,
                  label: "1.7Ã—"
              }, {
                  rate: 2,
                  label: "2Ã—"
              }],
              v = null,
              k = 1;
          const m = () => {
                  i.value = Math.floor(n.currentTime), u.textContent = y(i.value), t.style.setProperty("--seek-before-width", i.value / i.max * 100 + "%"), v = requestAnimationFrame(m)
              },
              p = e => {
                  e === i ? t.style.setProperty("--seek-before-width", e.value / e.max * 100 + "%") : t.style.setProperty("--volume-before-width", e.value / e.max * 100 + "%")
              },
              y = e => {
                  const t = Math.floor(e / 60),
                      a = Math.floor(e % 60);
                  return `${t}:${a<10?`0${a}`:`${a}`}`
              },
              h = () => {
                  c.textContent = y(n.duration)
              },
              L = () => {
                  i.max = Math.floor(n.duration)
              },
              f = () => {
                  if (n.buffered.length > 0) {
                      const e = Math.floor(n.buffered.end(n.buffered.length - 1));
                      t.style.setProperty("--buffered-width", e / i.max * 100 + "%")
                  }
              };
          n.readyState > 0 ? (h(), L(), f()) : n.addEventListener("loadedmetadata", (() => {
              h(), L(), f()
          })), a.addEventListener("click", (() => {
              a.classList.add("kg-audio-hide"), o.classList.remove("kg-audio-hide"), n.play(), requestAnimationFrame(m)
          })), o.addEventListener("click", (() => {
              o.classList.add("kg-audio-hide"), a.classList.remove("kg-audio-hide"), n.pause(), cancelAnimationFrame(v)
          })), r.addEventListener("click", (() => {
              r.classList.add("kg-audio-hide"), s.classList.remove("kg-audio-hide"), n.muted = !1
          })), s.addEventListener("click", (() => {
              s.classList.add("kg-audio-hide"), r.classList.remove("kg-audio-hide"), n.muted = !0
          })), d.addEventListener("click", (() => {
              let e = g[(k + 1) % 5];
              k += 1, n.playbackRate = e.rate, d.textContent = e.label
          })), n.addEventListener("progress", f), i.addEventListener("input", (e => {
              p(e.target), u.textContent = y(i.value), n.paused || cancelAnimationFrame(v)
          })), i.addEventListener("change", (() => {
              n.currentTime = i.value, n.paused || requestAnimationFrame(m)
          })), l.addEventListener("input", (e => {
              const t = e.target.value;
              p(e.target), n.volume = t / 100
          }))
      },
      t = document.querySelectorAll(".kg-audio-card");
  for (let a = 0; a < t.length; a++) e(t[a])
}(),
function() {
  const e = document.getElementsByClassName("kg-toggle-heading"),
      t = function(e) {
          const t = e.target.closest(".kg-toggle-card");
          "close" === t.getAttribute("data-kg-toggle-state") ? t.setAttribute("data-kg-toggle-state", "open") : t.setAttribute("data-kg-toggle-state", "close")
      };
  for (let a = 0; a < e.length; a++) e[a].addEventListener("click", t, !1)
}(),
function() {
  const e = function(e) {
          const t = e.querySelector(".kg-video-player"),
              a = e.querySelector(".kg-video-player-container"),
              o = e.querySelector(".kg-video-play-icon"),
              i = e.querySelector(".kg-video-pause-icon"),
              d = e.querySelector(".kg-video-seek-slider"),
              r = e.querySelector(".kg-video-playback-rate"),
              s = e.querySelector(".kg-video-mute-icon"),
              l = e.querySelector(".kg-video-unmute-icon"),
              n = e.querySelector(".kg-video-volume-slider"),
              c = e.querySelector("video"),
              u = e.querySelector(".kg-video-duration"),
              g = e.querySelector(".kg-video-current-time"),
              v = e.querySelector(".kg-video-large-play-icon"),
              k = e.querySelector(".kg-video-overlay");
          let m = [{
                  rate: .75,
                  label: "0.7Ã—"
              }, {
                  rate: 1,
                  label: "1Ã—"
              }, {
                  rate: 1.25,
                  label: "1.2Ã—"
              }, {
                  rate: 1.75,
                  label: "1.7Ã—"
              }, {
                  rate: 2,
                  label: "2Ã—"
              }],
              p = null,
              y = 1;
          c.loop && (v.classList.add("kg-video-hide-animated"), k.classList.add("kg-video-hide-animated"));
          const h = () => {
                  d.value = Math.floor(c.currentTime), g.textContent = f(d.value), t.style.setProperty("--seek-before-width", d.value / d.max * 100 + "%"), p = requestAnimationFrame(h)
              },
              L = e => {
                  e === d ? t.style.setProperty("--seek-before-width", e.value / e.max * 100 + "%") : t.style.setProperty("--volume-before-width", e.value / e.max * 100 + "%")
              },
              f = e => {
                  const t = Math.floor(e / 60),
                      a = Math.floor(e % 60);
                  return `${t}:${a<10?`0${a}`:`${a}`}`
              },
              q = () => {
                  u.textContent = f(c.duration)
              },
              b = () => {
                  d.max = Math.floor(c.duration)
              },
              S = () => {
                  if (c.buffered.length > 0) {
                      const e = Math.floor(c.buffered.end(c.buffered.length - 1));
                      t.style.setProperty("--buffered-width", e / d.max * 100 + "%")
                  }
              };
          c.readyState > 0 ? (q(), b(), S(), c.autoplay && (p = requestAnimationFrame(h), o.classList.add("kg-video-hide"), i.classList.remove("kg-video-hide")), c.muted && (l.classList.add("kg-video-hide"), s.classList.remove("kg-video-hide"))) : c.addEventListener("loadedmetadata", (() => {
              q(), b(), S(), c.autoplay && (p = requestAnimationFrame(h), o.classList.add("kg-video-hide"), i.classList.remove("kg-video-hide")), c.muted && (l.classList.add("kg-video-hide"), s.classList.remove("kg-video-hide"))
          })), e.onmouseover = () => {
              c.loop || a.classList.remove("kg-video-hide-animated")
          }, e.onmouseleave = () => {
              !!(c.currentTime > 0 && !c.paused && !c.ended && c.readyState > 2) && a.classList.add("kg-video-hide-animated")
          }, e.addEventListener("click", (() => {
              if (!c.loop) {
                  !!(c.currentTime > 0 && !c.paused && !c.ended && c.readyState > 2) ? P(): E()
              }
          })), c.onplay = () => {
              v.classList.add("kg-video-hide-animated"), k.classList.add("kg-video-hide-animated"), o.classList.add("kg-video-hide"), i.classList.remove("kg-video-hide")
          };
          const E = () => {
                  v.classList.add("kg-video-hide-animated"), k.classList.add("kg-video-hide-animated"), o.classList.add("kg-video-hide"), i.classList.remove("kg-video-hide"), c.play(), p = requestAnimationFrame(h)
              },
              P = () => {
                  i.classList.add("kg-video-hide"), o.classList.remove("kg-video-hide"), c.pause(), cancelAnimationFrame(p)
              };
          v.addEventListener("click", (e => {
              e.stopPropagation(), E()
          })), o.addEventListener("click", (e => {
              e.stopPropagation(), E()
          })), i.addEventListener("click", (e => {
              e.stopPropagation(), P()
          })), s.addEventListener("click", (e => {
              e.stopPropagation(), s.classList.add("kg-video-hide"), l.classList.remove("kg-video-hide"), c.muted = !1
          })), l.addEventListener("click", (e => {
              e.stopPropagation(), l.classList.add("kg-video-hide"), s.classList.remove("kg-video-hide"), c.muted = !0
          })), r.addEventListener("click", (e => {
              e.stopPropagation();
              let t = m[(y + 1) % 5];
              y += 1, c.playbackRate = t.rate, r.textContent = t.label
          })), c.addEventListener("progress", S), d.addEventListener("input", (e => {
              e.stopPropagation(), L(e.target), g.textContent = f(d.value), c.paused || cancelAnimationFrame(p)
          })), d.addEventListener("change", (e => {
              e.stopPropagation(), c.currentTime = d.value, c.paused || requestAnimationFrame(h)
          })), n.addEventListener("click", (e => {
              e.stopPropagation()
          })), d.addEventListener("click", (e => {
              e.stopPropagation()
          })), n.addEventListener("input", (e => {
              e.stopPropagation();
              const t = e.target.value;
              L(e.target), c.volume = t / 100
          }))
      },
      t = document.querySelectorAll(".kg-video-card");
  for (let a = 0; a < t.length; a++) e(t[a])
}();